// MATERIAL UI
import { useTheme } from "@mui/system";
import ContainedButton from "src/components/common/ContainedButton";
import { ClearIconWrapper } from "../styles/Trade.styles";

// ICONS
import CachedIcon from "@mui/icons-material/Cached";

interface IContainedButtonProps {
  isLoading?: boolean;
  text?: string;
  onClick?: () => void;
}

export const ClearButton = ({ isLoading = false, text, onClick }: IContainedButtonProps) => {
  const theme = useTheme();
  return (
    <ContainedButton
      id="clear-button"
      color={theme.palette.mode === "light" ? "neutral" : "dark"}
      borderRadius="20px"
      fontWeight={500}
      sx={{
        boxShadow: "none",
        border: "1px solid #E5E7E8",
        color: "#002035",
        width: "auto",
        minWidth: "88px",
        maxHeight: "32px",
        marginLeft: "auto",
        padding: "12px 16px",
        cursor: isLoading ? "default" : "pointer",
        pointerEvents: isLoading ? "none" : "auto",
        transition: "all 0.2s",
        "&:hover": {
          color: theme.palette.mode === "light" ? "#002035" : "#FFFFFF",
          background: theme.palette.mode === "light" ? "#F8F9F9" : "#121212",
        },
        "&:active": {
          background: "#002035",
          color: "#FFFFFF",
        },
      }}
      endIcon={
        <ClearIconWrapper isLoading={isLoading} data-testid="clear-button">
          <CachedIcon fontSize="small" sx={{ transform: "scaleX(-1)" }} />
        </ClearIconWrapper>
      }
      onClick={onClick}
      data-testid="clear-button">
      {text}
    </ContainedButton>
  );
};
